import React from"react";

const levelAccess = {
 basic: [true, true, false, false],
 advance: [true, true, false, false],
 premium: [true, true, true, true],
};

const levelLabels = ["Basic","Intermediate","Advance","Expert"];

const PracticeLevelSelector = ({ userPlan, onSelectLevel, onClose, onUnlockRequired }) => {
  return (
    <div
      style={{
        position:"fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background:"rgba(0, 0, 0, 0.8)", 
        backdropFilter:"blur(8px)",
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        zIndex: 2000
      }}
    >
      <div
        style={{
          background:"var(--bg-section)",
          border:"1px solid var(--accent-gray)",
          borderRadius:"32px",
          padding:"40px",
          boxShadow:"0 25px 50px rgba(31, 138, 203, 0.15)",
          minWidth: 380,
          textAlign:"center",
          position:"relative",
          overflow:"hidden"
        }}
      >
        <div style={{ position:"absolute", top: -50, right: -50, width: 150, height: 150, background:"var(--bg-soft)", borderRadius:"50%", filter:"blur(40px)" }}></div>
        
        <div style={{ fontWeight: 900, fontSize: 32, color:"var(--text-heading)", marginBottom: 12, textTransform:"uppercase", letterSpacing:"-0.02em" }}>
          Choose <span style={{ color:"var(--primary-blue)" }}>Level</span>
        </div>
        <p style={{ color:"var(--text-body)", fontSize:"16px", marginBottom: 32, fontWeight: 600 }}>Select your challenge difficulty</p>
        
        <div style={{ display:"flex", flexDirection:"column", gap: 16 }}>
          {levelLabels.map((label, idx) => {
            const isUnlocked = levelAccess[userPlan][idx];
            return (
              <button
                key={label}
                style={{
                  padding:"18px 24px",
                  borderRadius:"16px",
                  fontWeight: 800,
                  fontSize:"1.1rem",
                  background: isUnlocked
                    ?"#E3F2FD"
                    :"var(--bg-main)",
                  color: isUnlocked ?"var(--primary-blue)" :"var(--text-muted)",
                  border: isUnlocked ?"2px solid var(--primary-blue)" :"2px solid var(--accent-gray)",
                  cursor:"pointer",
                  transition:"all 0.3s ease",
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"space-between",
                  textAlign:"left",
                  boxShadow: isUnlocked ?"0 4px 12px rgba(43, 176, 230, 0.1)" :"none"
                }}
                onClick={() => {
                  if (isUnlocked) {
                    onSelectLevel(label);
                  } else {
                    onUnlockRequired && onUnlockRequired(label);
                  }
                }}
                onMouseEnter={(e) => {
                  if (isUnlocked) {
                    e.currentTarget.style.background ="var(--primary-blue)";
                    e.currentTarget.style.color ="#fff";
                    e.currentTarget.style.transform ="translateY(-2px)";
                    e.currentTarget.style.boxShadow ="0 10px 20px rgba(43, 176, 230, 0.3)";
                  } else {
                    e.currentTarget.style.borderColor ="var(--primary-blue)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (isUnlocked) {
                    e.currentTarget.style.background ="#E3F2FD";
                    e.currentTarget.style.color ="var(--primary-blue)";
                    e.currentTarget.style.transform ="translateY(0)";
                    e.currentTarget.style.boxShadow ="0 4px 12px rgba(43, 176, 230, 0.1)";
                  } else {
                    e.currentTarget.style.borderColor ="var(--accent-gray)";
                  }
                }}
              >
                <span>{label}</span>
                {!isUnlocked ? (
                  <span style={{ fontSize:"20px" }}>🔒</span>
                ) : (
                  <span style={{ fontSize:"20px" }}>→</span>
                )}
              </button>
            );
          })}
        </div>
        
        <button
          onClick={onClose}
          style={{
            marginTop: 32,
            background:"transparent",
            border:"none",
            color:"var(--text-muted)",
            fontWeight: 800,
            fontSize: 14,
            cursor:"pointer",
            textTransform:"uppercase",
            letterSpacing:"1px",
            transition:"all 0.2s"
          }}
          onMouseEnter={(e) => e.target.style.color ="var(--primary-blue)"}
          onMouseLeave={(e) => e.target.style.color ="var(--text-muted)"}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default PracticeLevelSelector;



